export default "__VITE_ASSET__04f29b14__"